








import { Bookshelf } from '@/utils/ResourceUtils';
import CategoryVue from '@/components/resource/display/Category.vue';
import ResourceVue from '@/components/resource/display/Resource.vue';
import mixins from 'vue-typed-mixins';
export default mixins().extend({
  components: {
    category: CategoryVue,
    resource: ResourceVue,
  },

  props: {
    value: {
      type: Object as () => Bookshelf,
    },
  },
});
